import { Files } from '../../lib/constants/files'
import { AdminStaffInput, AdminStaffRequest } from '../../lib/types/models/staff/admin-staff-input'
import { NullableTransformer } from '../../lib/types/utils'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const createStaff = async (data: AdminStaffInput) => {
  const picture = await uploadFile(Files.STAFF_PROFILE_PICTURE, data.picture)
  const criminalRecord = await uploadFile(Files.STAFF_CRIMINAL_RECORD, data.criminalRecord)
  const identityDocument = await uploadFile(Files.STAFF_IDENTITY_DOCUMENT, data.idFile)
  const paySlip = await uploadFile(Files.STAFF_PAYSLIP, data.paySlip)
  const eta = await uploadFile(Files.ETA, data.eta)
  const diplomas = data.diplomas.map(async (diploma) => ({
    ...diploma,
    file: await uploadFile(Files.STAFF_DIPLOMA, diploma.file)
  }))
  const req: NullableTransformer<AdminStaffRequest> = {
    ...data,
    availabilities: data.availabilities?.map(({ startDate, endDate }) => ({ startDate, endDate })),
    comments: data.comments?.map(
      ({ comment, displayForDirector, displayInPlanning, subject }) => ({
        comment,
        displayInPlanning,
        displayForDirector,
        subjectId: subject?.id
      })
    ),
    picture,
    criminalRecord,
    idFile: identityDocument,
    eta,
    paySlip,
    diplomas: await Promise.all(diplomas)
  }
  return restApiClient.url(constructApiUrl(API.staffs.create.url, null)).post(req)
}
